export interface ShipplayPartnerAgreementTermsContent {
  title: string
}

export const shipplayContent: ShipplayPartnerAgreementTermsContent = {
  title: 'Partner Agreement Terms',
}
